import {
    Card,
    Button,
    Badge,
    InfoSection,
    FormGroupInput,
    Checkbox
}
    from '@/components';
import {
    Select,
    Option,
    DatePicker
}
    from 'element-ui'
import gql from 'graphql-tag';
import axios from 'axios';
import mockdata from './tables/cashManagement/aacpVi_mock.json';
import mockdataaafliii from './tables/cashManagement/aafliii_mock.json';
import mockdataivoryiv from './tables/cashManagement/ivoryIv_mock.json';
import mockdatamdiv from './tables/cashManagement/MDIv_mock.json';
import { customCellEditor } from './tables/customCellEditor';
import "ag-grid-autocomplete-editor/dist/main.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AutocompleteSelectCellEditor } from "ag-grid-autocomplete-editor";
import {
    AgGridVue
} from "ag-grid-vue";
import AddEntityModal from '../components/modals/AddEntityModal.vue'
import AddProceduresModal from '../components/modals/AddProceduresModal.vue'
import FileReader from "@/components/fileReader.vue";
import asiaAltQueries from "@/graphql/asiaAltQueries";
import {
    mapState
} from 'vuex'
import {
    sqlTables
} from './tables'
import FormSchema, {
    Components
} from '@formschema/native'
import datePicker from '../components/customDatePicker.vue'
import customDialog from '../components/modals/customDialog.vue'
import Table from 'table-builder'
var filterParams = {
    comparator: function (filterLocalDateAtMidnight, cellValue) {
        var dateAsString = cellValue;
        var dateParts = dateAsString.split('/');
        var cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
        );
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        }
    },
};


const selectData = [];

const GET_EXCAVATIONS_CITATIONS = gql`
query getExcavationsCitations {
hasuraExcavationCitations {
DealID
DealLimit
CommonName
ARFundTermText
AsiaAltDiscount
Asia_Alt_GP_Legal_Entity
Asia_Alt_GP_Legal_Entity_Commitment
CarryRate
ClawBackDate
ClawBackIndemnity
ClawBackTiming
CommitDate
DealCurrency
DealLimitComps
DebtLimit
DebtLimitTerms
Description
FXRate
FeeStepDownDate
FinRepAnnual
FinRepQuarter
FinRepTax
FinalCloseDate
FiscalEndDate
GPCommitGF
GPCommitLE
GPEntity
GroupFundSize
HurdleRate
InitialCloseDate
InvDescription
InvEndDate
InvType
LEDomicile
LEFundSize
LEStructure
LETermDate
LETermDescription
LPCommitGF
LPCommitLE
LegalEntity
LiquidDate
LiquidNotes
MFeeDiscount
MFeeInitialBase
MFeeInitialRate
MFeeStepDownBase
MFeeStepDownRate
MFeeStepDownTime
MFeeTerms
Manager
OtherLimits
SOIGrouping
VintageYear
WaterFallTerms
WaterFallType
CommitmentFirstCommitmentDate
FolderPath
KeyPersons
AsiaAltOwnership
AsiaAltCommitmentAllAffiliates
AsiaAltGPLegalEntityCommitment
AsiaAltGPLegalEntity 
PEConsortium
}
}`

const GET_ENTITYDBS = gql`
query MyQuery {
EntityDB_allfields {
  ADVFiler
  ADVStatus
  AIFMDReg1
  AIFMDReg2
  AIFMDReg3
  AIFMDReg4
  AddCommit
  AddRegCountry
  AddRegDate
  AddRegNum
  AggCapCommit
  AltTaxID
  Amend1
  AnnRptDueDate
  BalCoEntity
  BalCommit
  BorrowLimit
  CACanDate
  CALPNum
  CARegDate
  CAStatus
  CFTCNoAction
  CIKNum
  CapCallPeriod
  CarryPct
  CarryTerms
  CoCommit
  CommodityPool
  CompanyName
  Country
  Custodian
  DealRef
  DissolveDate
  EIN
  ERISAPlan
  EntityType
  ExcessOrgExpAmt
  ExcessOrgExpCap
  FACTAReg
  FFARegNum
  FYEnd
  FinalClose
  FinraCRDNum
  ForeignCounsel
  FundAuditor
  FundFamily
  GIIN
  GP
  GPCommit
  ICAExempt
  InitClose
  InvAmtExclusions
  InvEndDate
  InvExt1
  InvExtProvisions
  InvRestrict
  InvStartDate
  LPCommit
  LargeTraderID
  LoC
  LocAmount
  MFeePct
  MFeeStepDate
  MFeeStepPct
  MFeeStepReason
  MFeeStepStatus
  MFeeStepVerb
  MFeeWaiverProvisions
  MainAddress
  MoneyMktAcctRestrict
  PFFiler
  PartnerEndDate
  PartnerExt1EndDate
  PartnerExt1Pursuant
  PartnerTerm
  PartnerTermExtProvisions
  PlaceAgent
  PreNoticeBorrowList
  PrefReturn
  PrimeBroker
  Purpose
  QualBusIn
  QuickRef
  RegAddress
  RegAgent
  RegDate
  RegNum
  SAClient
  SECFormDFile
  SECFormDNum
  SECPrivFundID
  State
  Status
  TaxProvider
  Tranche1Commit
  Tranche2Commit
  USCounsel
  column_8832ElectClass
  column_8832ElectDate
}
}`

const GET_ENTITYDBS_CD = gql`
query MyQuery {
  EntityDB_CompanyDetails {
    ADVFiler
    CACanDate
    CALPNum
    CARegDate
    CAStatus
    CompanyName
    Country
    Custodian
    DealRef
    DissolveDate
    EIN
    EntityType
    FYEnd
    ForeignCounsel
    FundAuditor
    FundFamily
    GP
    LoC
    LocAmount
    MainAddress
    PFFiler
    PlaceAgent
    PrimeBroker
    Purpose
    QuickRef
    RegAddress
    RegAgent
    RegDate
    RegNum
    SAClient
    State
    Status
    TaxProvider
    USCounsel
  }
}`

const GET_ENTITYDBS_LA = gql`
query MyQuery {
  EntityDB_LPAAmendments {
    AddCommit
    AggCapCommit
    Amend1
    Amend2
    Amend3
    Amend4
    Amend5
    Amend6
    Amend7
    Amend8
    BalCoEntity
    BalCommit
    BorrowLimit
    CapCallPeriod
    CarryPct
    CarryTerms
    CoCommit
    CompanyName
    Country
    ExcessOrgExpAmt
    ExcessOrgExpCap
    FinalCloseDate
    FundFamily
  }
}`

const GET_ENTITYDBS_RT = gql`
query MyQuery {
  EntityDB_RegulatoryTax {
      ADVStatus
      AIFMDReg1
      AIFMDReg2
      AIFMDReg3
      AIFMDReg4
      AddRegCountry
      AddRegDate
      AddRegNum
      AltTaxID
      column_8832ElectDate
      column_8832ElectClass
      Status
      SECPrivFundID
      SECFormDNum
      SECFormDFile
      QuickRef
      QualBusIn
      Purpose
      LargeTraderID
      ICAExempt
      GIIN
      FundFamily
      FinraCRDNum
      FFARegNum
      FACTAReg
      ERISAPlan
      Country
      CompanyName
      CommodityPool
      CIKNum
      AnnRptDueDate
    } 
}`

const GET_CASHMANAGEMENT_AAFLIII = gql`
query MyQuery {
    CashManagement_aacpVi {
     Deal
     WireDate
   }
}`

const GET_CASHMANAGEMENT_IVORYIV = gql`
 query MyQuery {
    CashManagement_aacpVi {
      Deal
      WireDate
    }
}`

const GET_EXCAVATIONS = gql`
query getExcavations {
hasuraExcavation {
Memo
DealID
DealLimit
CommonName
ARFundTermText
AsiaAltDiscount
Asia_Alt_GP_Legal_Entity
Asia_Alt_GP_Legal_Entity_Commitment
CarryRate
ClawBackDate
ClawBackIndemnity
ClawBackTiming
CommitDate
DealCurrency
DealLimitComps
DebtLimit
DebtLimitTerms
Description
FXRate
FeeStepDownDate
FinRepAnnual
FinRepQuarter
FinRepTax
FinalCloseDate
FiscalEndDate
GPCommitGF
GPCommitLE
GPEntity
GroupFundSize
HurdleRate
InitialCloseDate
InvDescription
InvEndDate
InvType
LEDomicile
LEFundSize
LEStructure
LETermDate
LETermDescription
LPCommitGF
LPCommitLE
LegalEntity
LiquidDate
LiquidNotes
MFeeDiscount
MFeeInitialBase
MFeeInitialRate
MFeeStepDownBase
MFeeStepDownRate
MFeeStepDownTime
MFeeTerms
Manager
OtherLimits
SOIGrouping
VintageYear
WaterFallTerms
WaterFallType
FolderPath
KeyPersons
AsiaAltOwnership
AsiaAltCommitmentAllAffiliates
AsiaAltGPLegalEntityCommitment
AsiaAltGPLegalEntity 
PEConsortium
}
}`

const GET_CASHMANAGEMENT_MDIV = gql`
query MyQuery {
    CashManagement_aacpVi {
      Deal
      WireDate
    }
 }`

const GET_CASHMANAGEMENT_AACPVI = gql`
query MyQuery {
   CashManagement_aacpVi {
     Deal
     WireDate
   }
}`

export default {
    name: 'home',
    bodyClass: 'tables',
    components: {
        Card,
        InfoSection,
        Badge,
        FileReader,
        customDialog,
        AgGridVue,
        AddEntityModal,
        AddProceduresModal,
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        [FormGroupInput.name]: FormGroupInput,
        [Select.name]: Select,
        [Option.name]: Option,
        datePicker
    },
    data() {
        return {
            slides: (function () {
                var slides = [];
                for (var i = 0; i < 600; i += 1) {
                    slides.push('Slide ' + (i + 1));
                }
                return [...slides];
            }()),
            virtualData: {
                slides: []
            },
            sortmodel: undefined,
            sorted: 0,
            drawersorted: 0,
            filereader: 0,
            modals: ['procedures'],
            rowsSelected: false,
            sheetChanged: false,
            deleteRows: false,
            rowsupdated: [],
            direction: 'ltr',
            currentRow: undefined,
            settings: {
                suppressScrollY: false,
                suppressScrollX: false,
            },
            drawer: false,
            mutations: {
                UPSERT_EXCAVATIONS: gql`mutation UpsertExcavation($data: String!) {
                                      upsertExcavation(data: $data) {
                                      success
                                      }
                                     }`,
                DELETE_EXCAVATIONS: gql`mutation DeleteExcavation($data: String!) {
                                      deleteExcavation(data: $data) {
                                      success
                                      }
                                     }`,
                UPSERT_ENTITYDBS: gql`mutation UpsertEntityDB($data: String!) {
                                      upsertEntityDB(data: $data) {
                                      success
                                      }
                                     }`,
                DELETE_ENTITYDBS: gql`mutation DeleteEntityDB($data: String!) {
                                      deleteEntityDB(data: $data) {
                                      success
                                      }
                                     }`,
                UPSERT_ENTITYDBCDS: gql`mutation Update_EntityDB_CompanyDetails($CompanyName: String!, $EntityDB_CompanyDetails_set_input: EntityDB_CompanyDetails_set_input) {
                                        update_EntityDB_CompanyDetails_by_pk(pk_columns: {CompanyName: $CompanyName}, _set: $EntityDB_CompanyDetails_set_input){
                                            CompanyName
                                        }
                                    }`,
                UPSERT_ENTITYDBLAS: gql`mutation Update_EntityDB_LPAAmendments($CompanyName: String!, $EntityDB_LPAAmendments_set_input: EntityDB_LPAAmendments_set_input) {
                                        update_EntityDB_LPAAmendments_by_pk(pk_columns: {CompanyName: $CompanyName}, _set: $EntityDB_LPAAmendments_set_input){
                                            CompanyName
                                        }
                                    }`,
                UPSERT_ENTITYDBRTS: gql`mutation Update_EntityDB_RegulatoryTax($CompanyName: String!, $EntityDB_RegulatoryTax_set_input: EntityDB_RegulatoryTax_set_input) {
                                        update_EntityDB_RegulatoryTax_by_pk(pk_columns: {CompanyName: $CompanyName}, _set: $EntityDB_RegulatoryTax_set_input){
                                            CompanyName
                                        }
                                    }`,
                DELETE_ENTITYDBCDS: gql`mutation Delete_EntityDB_CompanyDetails($CompanyName: String!) {
                                        delete_EntityDB_CompanyDetails_by_pk(CompanyName: $CompanyName){
                                            CompanyName
                                        }
                                    }`,
                DELETE_ENTITYDBLAS: gql`mutation Delete_EntityDB_LPAAmendments($CompanyName: String!) {
                                        delete_EntityDB_LPAAmendments_by_pk(CompanyName: $CompanyName){
                                            CompanyName
                                        }
                                    }`,
                DELETE_ENTITYDBRTS: gql`mutation Delete_EntityDB_RegulatoryTax($CompanyName: String!) {
                                        delete_EntityDB_RegulatoryTax_by_pk(CompanyName: $CompanyName){
                                            CompanyName
                                        }
                                    }`,
                INSERT_ENTITYDBCDS: gql`mutation Insert_EntityDB_CompanyDetails($EntityDB_CompanyDetails_insert_input: [EntityDB_CompanyDetails_insert_input!]!) {
                                        insert_EntityDB_CompanyDetails(objects: $EntityDB_CompanyDetails_insert_input) {     
                                            affected_rows
                                            returning{
                                                CompanyName
                                            }   
                                        }
                                    }`,
                INSERT_ENTITYDBLAS: gql`mutation Insert_EntityDB_LPAAmendments($EntityDB_LPAAmendments_insert_input: [EntityDB_LPAAmendments_insert_input!]!) {
                                        insert_EntityDB_LPAAmendments(objects: $EntityDB_LPAAmendments_insert_input) {     
                                            affected_rows
                                            returning{
                                                CompanyName
                                            }   
                                        }
                                    }`,
                INSERT_ENTITYDBRTS: gql`mutation Insert_EntityDB_RegulatoryTax($EntityDB_RegulatoryTax_insert_input: [EntityDB_RegulatoryTax_insert_input!]!) {
                                        insert_EntityDB_RegulatoryTax(objects: $EntityDB_RegulatoryTax_insert_input) {     
                                            affected_rows
                                            returning{
                                                CompanyName
                                            }   
                                        }
                                    }`

            },
            formstate: {},
            model: {},
            series: [],
            sheetChanges: [],
            auditLog: [],
            module: this.$store.getters.get('module') || 'Clients',
            subModule: this.$store.getters.get('subModule') || '',
            filteredData: this.setFilter && this.setFilter.selectedRows && this.setFilter.selectedRows.length > 0 ? this.setFilter.selectedRows : this.rowData ? this.rowData : []
        }
    },
    apollo: {
        hasuraExcavation: {
            query: GET_EXCAVATIONS
        }
    },
    computed: {
        ...mapState({
            gqlmap: 'gqlmap',
            slideWrapper: 'slideWrapper'
        }),
        slideStyles() {
            return `left: ${this.virtualData.offset}px;`;
        },
        slides2: function () {
            return this.filteredData;
        },
        keyfield: function () {
            return this.gqlmap === 'excavation' ? 'DealID' : (this.gqlmap === 'entitydb' || this.gqlmap === 'entitydbCd' || this.gqlmap === 'entitydbLa' || this.gqlmap === 'entitydbRt') ? 'CompanyName' : (this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv') ? 'Deal' : 'FundName'
        },
        spinner: {
            get: function () {
                return this.$store.getters.get('spinner');
            },
            set: function (val) {
                this.$store.commit('change', {
                    spinner: val
                })
            }
        },
        mapping: {
            get: function () {
                let w = this;
                return sqlTables[w.gqlmap] && sqlTables[w.gqlmap].mapping ? sqlTables[w.gqlmap].mapping : {}
            },
            set: function (val) {
                let w = this;
                sqlTables[w.gqlmap].mapping = val;
            }
        },
        aggregatedSeries: function () {
            let w = this;
            let mapping = sqlTables[w.gqlmap] ? sqlTables[w.gqlmap].mapping : {}
            let agg = {}
            if (w.series.length == 0) {
                return w.series
            } else {
                w.series.map((x, i) => {
                    let total = 0
                    let disc;
                    Object.keys(x).map(y => {
                        if (mapping[y] && mapping[y].sum && !isNaN(parseInt(x[y]))) total = total + parseInt(x[y])
                        if (mapping[y] && mapping[y].sum && x[y] && !isNaN(parseInt(x[y]))) {
                            agg[y] = agg[y] ? parseInt(agg[y]) + parseInt(x[y]) : parseInt(x[y])
                        } else {
                            agg[y] = null
                        }
                    })
                    agg['Calculated_Commitment'] = total
                    if (!isNaN(parseInt(x['Total__Commitment']))) agg['Discrepancy'] = agg['Total__Commitment'] - agg['Calculated_Commitment']
                })
            }
            agg.FundName = 'AGGREGATES'
            let seriesarray = []
            let series = [agg].concat(w.series);
            series.map(x => {
                let array = [];
                Object.keys(x).map(y => {
                    array.push({
                        key: y,
                        data: x[y]
                    })
                })
                seriesarray.push(array);
            })
            return series
        },
        appClass: {
            set: function (value) {
                this.$store.commit('change', {
                    appclass: value
                })
            },
            get: function (value) {
                return this.$store.getters.get('appclass')
            }
        },
        swiperOptions: function () {
            let w = this;
            let opts = {
                cssMode: true,
                allowTouchMove: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                virtual: {
                    slides: [...w.filteredData],
                    renderExternal(data) {
                        w.virtualData = data;
                    }
                }
            };
            return opts;
        },
        options: function () {
            let w = this;
            let slides = []
            let data = w.filteredData
            let mapping = sqlTables[this.gqlmap].mapping
            let citations = this.citations && Object.keys(this.citations).length > 0 ? this.citations : false;
            let opts = {
                cssMode: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                virtual: {
                    slides: slides
                }
            };
            return opts;
        },
        rowData: function () {
            return this.aggregatedSeries.filter(x => x[this.keyfield]);
        },
        customDateFormat() {
            let MyDate = new Date()
            let MyDateString = ('0' + MyDate.getDate()).slice(-2) + ('0' + (MyDate.getMonth() + 1)).slice(-2) + MyDate.getFullYear().toString().substr(2, 4);
            return MyDateString;
        },
        sheet: function () {
            return false;
            var w = this;
            if (this.chartJSON) {
                var json = this.chartJSON;
                var rows = [];
                let components = JSON.parse(JSON.stringify(w.components))
                components.sort((a, b) => a > b ? 1 : a < b ? -1 : 0)
                var columns = ['sample'].concat(components)
                rows.push(columns);
                json.forEach(function (p) {
                    var result = []
                    result.push(p.profile);
                    components.map(n => {
                        var pct = p.result[n] ? p.result[n] : 0
                        result.push(pct)
                    })
                    rows.push(result)
                })
                return rows;
            } else {
                return null;
            }
        },
        columnDefs: function () {
            if (this.series && this.series.length > 0) {
                var columns = [];
                var comp = Object.keys(this.mapping)
                if (this.gqlmap === 'commitment') {
                    comp.sort((a, b) => this.mapping && this.mapping[a] && this.mapping[a].inserted ? 1 : -1)
                }
                var w = this;
                let meta = {},
                    pinned = [],
                    width = [],
                    immutable = {};
                var index = false;
                if (sqlTables[this.gqlmap]) {
                    meta = sqlTables[this.gqlmap]
                    pinned = sqlTables[this.gqlmap].pinned
                    width = sqlTables[this.gqlmap].width
                    immutable = sqlTables[this.gqlmap].immutable
                }
                comp.forEach(function (c, n) {
                    let checked = 0;
                    if (c !== 'id' && c !== '__typename' && c !== 'system_modified' && (w.mapping[c] && !w.mapping[c].hidden)) {

                        if (pinned.indexOf(c) >= 0) {
                            index = true;
                            var obj = {
                                headerName: w.mapping[c].header,
                                headerTooltip: w.mapping[c].header,
                                checkboxSelection: c == w.keyfield ? true : false,
                                field: c,
                                pinned: 'left',
                                tooltipField: c,
                                floatingFilter: true,
                                minWidth: width[c] ? width[c] : c.length > 6 ? 120 : c.length > 10 ? 180 : 80,
                                editable: immutable[c] ? false : true,
                                filter: true,
                                resizable: false,
                                rowDrag: false,
                                headerClass: 'header-sample',
                                cellStyle: {
                                    backgroundColor: '#f2f2f2',
                                    textTransform: 'uppercase',
                                    borderBottom: 'none',
                                    textAlign: c === 'DealID' ? 'center' : 'left',
                                    paddingRight: c === 'DealID' ? '10px' : '22px',
                                    fontSize: '10px'
                                },
                            }
                        } else {
                            var obj = {};
                            obj.editable = immutable[c] ? false : true,
                                obj.floatingFilter = true;
                            obj.tooltipField = c;
                            obj.minWidth = width[c] ? width[c] : c.length > 6 ? 120 : c.length > 10 ? 180 : 100,
                                obj.headerName = w.mapping[c] && w.mapping[c].header ? w.mapping[c].header : (c.charAt(0).toUpperCase() + c.slice(1)).replace(/_/g, ' ');
                            obj.headerTooltip = obj.headerName;
                            if (c.endsWith('Date') || w.mapping[c] && w.mapping[c].dataType == 'date') {
                                obj.headerName = obj.headerName.replace(/date/, ' Date');
                                obj.valueFormatter = function (data) {
                                    if (data.value && Date.parse(data.value) > 0) {
                                        return w.handledateFormatter(w.$moment.utc(data.value).format('L'))
                                    }
                                }
                                obj.cellEditor = customCellEditor;
                                obj.filter = 'agDateColumnFilter'
                                obj.filterParams = {
                                    buttons: ['reset'],
                                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                                        const dateAsString = cellValue;
                                        if (dateAsString == null || Date.parse(dateAsString) <= 0) {
                                            return 0;
                                        }

                                        const dateParts = dateAsString.split('/');
                                        const day = Number(dateParts[2]);
                                        const month = Number(dateParts[1]) - 1;
                                        const year = Number(dateParts[0]);
                                        const cellDate = new Date(year, month, day);

                                        if (cellDate < filterLocalDateAtMidnight) {
                                            return -1;
                                        } else if (cellDate > filterLocalDateAtMidnight) {
                                            return 1;
                                        }
                                        return 0;
                                    }
                                }
                            } else {
                                obj.headerClass = w.mapping[c] && w.mapping[c].inserted ? 'header-inserted' : '';
                                obj.cellEditor = w.mapping[c] && w.mapping[c].cellEditor === "agTextCellEditor" ? customCellEditor : (w.mapping[c].cellEditor === "autoCompleteCellEditor") ? AutocompleteSelectCellEditor : 'agLargeTextCellEditor';
                                if(w.mapping[c] && w.mapping[c].cellEditor === "autoCompleteCellEditor") {
                                    obj.cellEditorParams= {
                                        required: true,
                                        selectData: selectData,
                                        placeholder: "Select an option"
                                    }
                                    
                                } else {
                                    obj.cellEditorParams = {
                                        maxLength: 8000
                                    };
                                }
                            }
                            if(c == "FRBBalancedCKG") {
                                //obj.valueGetter =  function (data) {
                                //    var balanceCKG = w.getCellFormattedValue(data.data.BalancedCKG);
                                //    var coInvestCKG =w.getCellFormattedValue(data.data.CoInvestCKG);
                                //    return w.handleNegetiveValue(balanceCKG + coInvestCKG);
                                //}
                            }
                            if(c == "CoInvestCKG" || c == "BalancedCKG") {
                                obj.suppressNavigable = true;
                            }
                            if(w.gqlmap == "aacpVi" && c == "Total"){
                                obj.valueGetter =  function (data) {
                                    var noMMA = w.getCellFormattedValue(data.data.NoMMA)
                                    var cKG = w.getCellFormattedValue(data.data.CKG)
                                    return w.handleNegetiveValue(noMMA + cKG);
                                }
                            }
                            else if(c == "Total") {
                                obj.valueGetter =  function (data) {
                                    var calcFRBBalancedCKG = w.getCellFormattedValue(data.getValue('FRBBalancedCKG'))
                                    var balanceMMA = w.getCellFormattedValue(data.data.BalancedMMA);
                                    var coInvestMMA = w.getCellFormattedValue(data.data.CoInvestMMA);
                                    var fRBCoInvestCKG = w.getCellFormattedValue(data.data.FRBCoInvestCKG);
                                    return  w.handleNegetiveValue(parseFloat(parseFloat(balanceMMA + coInvestMMA + calcFRBBalancedCKG + fRBCoInvestCKG).toFixed(2)));
                                }
                            }
                            if(c == "CashBalance"){
                                obj.valueGetter =  function (data) {
                                    var rowIndex =  parseFloat(data.node.id)
                                    var calcTotal = w.getCellFormattedValue(data.getValue('Total'))
                                    var getCashBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CashBalance) : 0;
                                    return  w.handleNegetiveValue(parseFloat(parseFloat(getCashBalance + calcTotal).toFixed(2)));
                                }
                            }
                            if(w.gqlmap == "aacpVi" && c == "CKGBalance"){
                                obj.valueGetter =  function (data) {
                                    var rowIndex =  parseFloat(data.node.id)
                                    var calcCKG = w.getCellFormattedValue(data.getValue('CKG'))
                                    var getCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CKGBalance) : 0;
                                    return w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + calcCKG).toFixed(2)));
                                }
                            }
                            else if(c == "CKGBalance"){
                                obj.valueGetter =  function (data) {
                                    var rowIndex =  parseFloat(data.node.id)
                                    var calcBalancedCKG = w.getCellFormattedValue(data.getValue('BalancedCKG'))
                                    var getCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CKGBalance) : 0;
                                    return w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + calcBalancedCKG).toFixed(2)));
                                }
                            }
                            if(c == "CoInvestCKGBalance"){
                                obj.valueGetter =  function (data) {
                                    var rowIndex =  parseFloat(data.node.id)
                                    var calcCoInvestCKG = w.getCellFormattedValue(data.getValue('CoInvestCKG'))
                                    var getCoInvestCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CoInvestCKGBalance) : 0;
                                    return  w.handleNegetiveValue(parseFloat(parseFloat(getCoInvestCKGBalance + calcCoInvestCKG).toFixed(2)));
                                }
                            }
                            if (w.mapping[c] && w.mapping[c].type === 'commitment') {
                                obj.cellStyle = {
                                    backgroundColor: 'brown',
                                };
                            }
                            obj.field = c;
                            obj.resizable = true,
                                obj.filter = obj.filter ? obj.filter : true;
                            obj.cellStyle = function (data) {
                                if (data.data.rowModfied) { }
                                return {
                                    textAlign: c.endsWith('Date') ? 'center' : w.mapping[c].textAlign === 'right' ? 'right' : 'left',
                                    paddingLeft: '10px',
                                    paddingRight: '10px'
                                }
                            };
                        }
                        obj.filterParams = obj.filterParams ? obj.filterParams : {
                            buttons: ['reset']
                        }
                        obj.sortable = true;
                        obj.cellRenderer = w.mapping[c] && w.mapping[c].dataType && w[`render${w.mapping[c].dataType}`] ? w[`render${w.mapping[c].dataType}`] : null
                        obj.valueFormatter = function (data) {
                            if (data && data.value && w.mapping[c] && w.mapping[c].dataType === 'number' && !isNaN(parseInt(data.value)) && c != w.keyfield) {
                                let value = parseInt(data.value).toFixed(0);
                                var formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                if (parseInt(data.value) < 0) formatted = `(${formatted.replace(/-/, '')})`
                                if (parseInt(data.value) == 0 || isNaN(parseInt(data.value))) {
                                    formatted = '-'
                                } else { }
                                return formatted
                            }
                            if (c.endsWith('Date') || w.mapping[c] && w.mapping[c].dataType == 'date') {
                                obj.headerName = obj.headerName.replace(/date/, ' Date');
                                if (data.value && Date.parse(data.value) > 0) {
                                    return w.handledateFormatter(w.$moment.utc(data.value).format('L'))
                                }
                            }
                            if (data && data.value && w.mapping[c] && w.mapping[c].dataType === 'percent' && !isNaN(parseInt(data.value))) {
                                return (parseFloat(data.value) * 100).toFixed(2) + '%'
                            }
                        }
                        columns.push(obj);
                    }
                })
                let newcolumns = []
                columns.map(x => {
                    let c = x.field;
                    if (w.mapping[c] && w.mapping[c].type === 'commitment' && w.mapping[c].inserted) newcolumns.push(x)
                })
                columns.map(x => {
                    let c = x.field;
                    if (w.mapping[c] && w.mapping[c].type === 'commitment' && !w.mapping[c].inserted) newcolumns.push(x)
                })
                columns.map(x => {
                    let c = x.field;
                    if (w.mapping[c] && w.mapping[c].type !== 'commitment') newcolumns.push(x)
                })
                return newcolumns
            } else {
                var columns = null;
                return columns;
            }
        },
    },
    watch: {
        $route(to, from) {
            this.setModule()
            this.runQuery();
        }
    },
    beforeMount() {
        this.frameworkComponents = {
            agDateInput: datePicker
        };
        let w = this;
        this.gridOptions = {
            headerHeight: 60,
            tooltipShowDelay: 5,
            cellFlashDelay: 500000000,
            rowClassRules: {
                'modified': function (params) {
                    return params.data.system_modified === true || params.data['FundName'] === 'aAGGREGATES';
                },
                'aggregated': function (params) {
                    return params.data['FundName'] === 'AGGREGATES';
                },
            },
            enableBrowserTooltips: false,
            animateRows: false,
            defaultColDef: {
                flex: 1,
                minWidth: 150,
                suppressClickEdit: true,
                filter: true
            },
            pagination: true,
            paginationPageSize: 20,
            onFirstDataRendered: function (params) { },
            onModelUpdated: function (params) {
                setTimeout(function () {
                    params.api.sizeColumnsToFit();
                })
            },
            onGridReady: function (params) {
                window.addEventListener('resize', function () {
                    setTimeout(function () {
                        params.api.sizeColumnsToFit();
                    })
                })
            },
        }
    },
    created() {
        this.agcomponents = {};
    },
    mounted() {
        this.splitdata = []
        this.dataChanges = []
        this.rowsupdated = []
        this.deleteRows = false;
        this.citations = {}
        this.drawersorted = Date.now()
        this.sorted = Date.now()
        this.filereader = Date.now()
        this.runQuery(true)
        this.getSplitData();
    },
    methods: {
        getSplitData() {
                let w = this;
                var data = JSON.stringify({
                    "FundID": "222"
                  });
                  
                  var config = {
                    method: 'post',
                    url: 'https://asiaaltfunctions.azurewebsites.net/api/querySplits?code=hgG_DtbepOvlh2l-Ep01sYMOMyZkSUsqnQDZHSDgVRgZAzFuX5Uz-A==',
                    headers: { 
                      'Content-Type': 'application/json'
                    },
                    data : data
                  };
                  
                  axios(config)
                  .then(function (response) {
                    w.splitdata = response.data; 
                    const uniqueData = w.getUniqueListBy(response.data, 'iLevel Deal Name');
                    uniqueData.forEach(element => {
                        selectData.push({ value: element['iLevel Deal Name'], label: element['iLevel Deal Name'] })
                    });

                  })
                  .catch(function (error) {
                    console.log(error);
                  });
            
        },
        getUniqueListBy(arr, key) {
            return [...new Map(arr.map(item => [item[key], item])).values()]
        },
        log(evt) {
            let w = this;
            if (evt == 'drawer') {
                if (w.savedState) {
                    w.gridOptions.api.setFilterModel();
                }
                if (w.filterState) {
                    w.gridOptions.api.setFilterModel(w.filterState);
                }
            }
        },
        beforeCloseDrawer(done) {
            return done(true)
        },
        getCellFormattedValue(value) {
            if(value === undefined || value == "" || value === null || value == '(NaN)'){
                return 0;
            } else {
                var regExp = /\(([^)]+)\)/;
                value = value.toString().replace(/,/g, '');
                var match = regExp.exec(value);
                var data = (match === null) ? value : '-'+match[1];
                var result = parseFloat(parseFloat(data).toFixed(2));
                return result;
            }
        },
        handleNegetiveValue(value){
            value = value.toString().replace(/,/g, '');
            var result = parseFloat(value) >= 0 ? value : '('+(Math.abs(value))+')';
            return result.replace(/\B(?=(\d{3})+(?!\d))/g, ','); 
        },
        handledateFormatter(value){
            var date = new Date(value);
            const formattedData = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());
            return formattedData;
        },
        getDatePicker() {
            function Datepicker() {
                datePicker.prototype.init = function (params) {
                    this.eInput = document.createElement("input");
                    this.eInput.setAttribute("type", "date");
                    this.cell = params.eGridCell;
                    this.oldWidth = this.cell.style.width;
                    this.cell.style.width = "162px";
                    this.eInput.value = params.value;
                };
                datePicker.prototype.getGui = function () {
                    return this.eInput;
                };
                datePicker.prototype.afterGuiAttached = function () {
                    this.eInput.focus();
                    this.eInput.select();
                };
                datePicker.prototype.getValue = function () {
                    this.cell.style.width = this.oldWidth;
                    return this.eInput.value;
                };
                datePicker.prototype.destroy = function () { };
                datePicker.prototype.isPopup = function () {
                    return false;
                };
            }
            return Datepicker;
        },
        scrollHandle(evt) { },
        resetChanges: function () {
            let w = this;
            let buttons = [{
                title: 'Reset',
                handler: () => {
                    w.setFilter = undefined
                    w.rowsupdated = [];
                    w.gridApi.deselectAll();
                    w.gridApi.flashCells({
                        rowNodes: []
                    })
                    w.$modal.hide('dialog');
                    setTimeout(() => {
                        w.dataChanges = [];
                        w.sheetChanges = [];
                        w.auditLog = [];
                        w.sheetChanged = false;
                        w.runQuery(true);
                    }, 100)
                }
            },

            {
                title: 'Cancel',
                default: true,
                handler: () => {
                    w.$modal.hide('dialog');
                }
            }
            ]
            this.$modal.show('dialog', {
                title: 'Are you sure?',
                width: '600px',
                maxHeight: '600px',
                text: 'You have unsaved changes, these will be lost if you reset',
                class: 'warning',
                buttons: buttons
            })
        },
        deleteSelection: function () {
            let w = this;
            let rowsSelected = [...this.gridApi.getSelectedRows()];
            rowsSelected = rowsSelected.map(x => x[w.keyfield]).filter(x => x !== undefined)
            let buttons = [{
                title: 'Delete',
                handler: () => {
                    let data = []
                    let user = w.$store.getters.get('user')
                    user = user && user.username ? user.username : 'unknown'
                    rowsSelected.map(x => {
                        let obj = {}
                        obj[w.keyfield] = x;
                        obj.action = 'delete';
                        obj.audit = {
                            user: user,
                            key: w.keyfield,
                            old: x,
                            new: 'deleted',
                            timestamp: Date.now()
                        }
                        data.push(obj);
                    })
                    this.deleteSQLData(data);
                    w.$modal.hide('dialog');
                }
            },

            {
                title: 'Cancel',
                default: true,
                handler: () => {
                    w.$modal.hide('dialog');
                }
            }
            ]
            this.$modal.show('dialog', {
                title: 'Caution!',
                width: '600px',
                maxHeight: '600px',
                text: `Deletes are not reversible, ` + (rowsSelected.length > 1 ? `these (${rowsSelected.length}) records` : 'this record') + ` will be removed permanently`,
                class: 'failure',
                buttons: buttons
            })
        },
        updateCitation: function (key, field, value) {
            let w = this;
            let update = function () {
                let rowindex = w.rowData.findIndex(z => z[w.keyfield] == key)
                let rowNode = w.gridApi.getRowNode(rowindex)
                if (w.rowsupdated.findIndex(x => x.rowIndex == rowNode.rowIndex) < 0) {
                    w.rowsupdated.push(rowNode);
                }
                w.gridApi.flashCells({
                    rowNodes: w.rowsupdated
                })
                w.gridApi.deselectAll();
                let name = 'Citation > ' + key
                let user = w.$store.getters.get('user')
                user = user && user.username ? user.username : 'unknown'
                let oldValue = w.citations[key][field]
                let audit = {
                    user: user,
                    key: key,
                    old: oldValue ? oldValue : 'Empty',
                    new: value,
                    timestamp: Date.now()
                }
                let change = `<p class='dialog-text'>${name} > ${field}<br/><i style='color:brown'>${oldValue ? oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${value}</i></p>`
                if (w.citations[key] && w.citations[key][field]) {
                    if (w.sheetChanges.findIndex(x => x === change) < 0) {
                        value = value == null || value == undefined || value == '' ? '-' : value
                        w.citations[key][field] = value;
                        if (w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key) >= 0) {
                            let index = w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key)
                            w.citations[key].dataType = 'citation'
                            w.dataChanges[index] = w.citations[key]
                            w.auditLog.push(audit)
                            w.sheetChanges.push(change)
                            w.sheetChanged = true;
                        } else {
                            w.citations[key].dataType = 'citation'
                            w.dataChanges.push(w.citations[key])
                            w.auditLog.push(audit)
                            w.sheetChanges.push(change)
                            w.sheetChanged = true;
                        }
                    } else {
                        let sheetindex = w.sheetChanges.findIndex(x => x === change)
                        value = value == null || value == undefined || value == '' ? '-' : value
                        w.citations[key][field] = value;
                        if (w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key) >= 0) {
                            let index = w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key)
                            w.citations[key].dataType = 'citation'
                            w.dataChanges[index] = w.citations[key]
                            w.auditLog.push(audit)
                            w.sheetChanges[sheetindex] = change
                            w.sheetChanged = true;
                        } else {
                            w.citations[key].dataType = 'citation'
                            w.dataChanges.push(w.citations[key])
                            w.auditLog.push(audit)
                            w.sheetChanges[sheetindex] = change
                            w.sheetChanged = true;
                        }

                    }
                }
            }
            clearTimeout(w.debounce)
            w.debounce = setTimeout(() => {
                update()
            }, 1000)
        },
        updateRow: function (field, value, key, oldValue) {
            let w = this;
            let index = w.filteredData.findIndex(z => z[w.keyfield] == key)
            if (field && key && (value != oldValue)) {
                let update = function () {
                    let rowindex = w.filteredData.findIndex(z => z[w.keyfield] == key)
                    if (rowindex >= 0) {
                        let data = w.rowData[rowindex]
                        data.rowIndex = rowindex
                        let rowNode = w.gridApi.getDisplayedRowAtIndex(rowindex)
                        if (w.rowsupdated.findIndex(x => x.rowIndex == rowNode.rowIndex) < 0) {
                            w.rowsupdated.push(rowNode);
                        }
                        let name = w.series[rowindex][w.keyfield]
                        let user = w.$store.getters.get('user')
                        user = user && user.username ? user.username : 'unknown'
                        let audit = {
                            user: user,
                            key: data[w.keyfield],
                            old: oldValue ? oldValue : 'Empty',
                            new: value,
                            timestamp: Date.now()
                        }
                        let change = `<p class='dialog-text'>${name} > ${field}<br/><i style='color:brown'>${oldValue ? oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${value}</i></p>`
                        if (w.sheetChanges.findIndex(x => x === change) < 0) {
                            if (w.dataChanges.findIndex(x => x.rowIndex == data.rowIndex) >= 0) w.dataChanges.splice(w.dataChanges.findIndex(x => x.rowIndex == data.rowIndex), 1)
                            w.dataChanges.push(data)
                            w.auditLog.push(audit)
                            w.sheetChanges.push(change)
                            w.sheetChanged = true;
                        }
                        w.gridApi.flashCells({
                            rowNodes: w.rowsupdated
                        })
                        w.gridApi.deselectAll();
                    }
                }
                update()
            }
        },
        setFormat: function (key, field, val) {
            let w = this;
            let index = w.filteredData && w.filteredData[0] ? w.filteredData.findIndex(z => z[w.keyfield] == key) : false
            let value = val
            let oldVal = w.filteredData[index][field]
            if (index >= 0 && (oldVal !== value)) {
                let type = w.mapping[field] && w.mapping[field].dataType ? w.mapping[field].dataType : field.indexOf('Date') >= 0 ? 'date' : 'text'
                value = value && type == 'number' ? value.toString().replace(/,/g, '') : value
                clearTimeout(w.debounce);
                w.debounce = setTimeout(() => {
                    let id = w.rowData.findIndex(x => x[w.keyfield] == key)
                    let rowNode = w.gridOptions.api.getRowNode(id);
                    if (rowNode) {
                        let testval = rowNode.data[field]
                        if (testval !== value) {
                            rowNode.setDataValue(field, value);
                        }
                    }
                }, type == 'date' ? 2000 : 1000)
            }
        },
        fieldFormatter: function (key, field, val) {
            let w = this;
            let type = w.mapping[field] && w.mapping[field].dataType ? w.mapping[field].dataType : field.indexOf('Date') >= 0 ? 'date' : 'text'
            const formatters = {
                date: function (val, field) {
                    if (Date.parse(val) >= 0) {
                        let date = new Date(val);
                        let formattedDate = w.handledateFormatter(val)
                        if (date.getFullYear() == '1969') {
                            return ''
                        } else {
                            return formattedDate
                        }
                    } else {
                        return ''
                    }
                },
                percenta: function (val) {
                    let pct = !isNaN(parseFloat(val)) ? (100 * parseFloat(val)).toFixed(2) + '%' : val
                    return pct
                },
                text: function (val) {
                    return val
                },
                number: function (val, field) {
                    let value = val ? parseInt(val.toString().replace(/,/g, '')).toFixed(0) : val
                    var formatted = field == w.keyfield ? val : value ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : val
                    if (!isNaN(parseInt(val)) && parseInt(val) < 0) formatted = `(${formatted.replace(/-/, '')})`
                    if (parseInt(val) == 0 || isNaN(parseInt(val))) {
                        formatted = '-'
                    } else { }
                    return formatted
                },
                currency: function (val) {
                    return val
                },
            }
            if (formatters[type]) {
                return formatters[type](val, field)
            } else {
                return val
            }
        },
        debounce2: function (func, wait, timeout) {
            var timeout;
            return function () {
                var context = this,
                    args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        },
        loadTextFromFile(ev) {
            const file = ev.target.files[0];
            const reader = new FileReader();
            reader.onload = e => {
                console.log(e);
            }
            reader.readAsArrayBuffer(file);
        },
        getEntitydbs: async function () {
            let queryEntity = GET_ENTITYDBS;
            if (gqlmap == 'entitydbCd') {
                queryEntity = GET_ENTITYDBS_CD;
            } else if (gqlmap == 'entitydbLa') {
                queryEntity = GET_ENTITYDBS_LA;
            }
            this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                let data = await this.$apollo.query({
                    query: queryEntity,
                    fetchPolicy: 'network-only'
                })
                return (data ? data : {
                    data: {
                        data: {
                            entitydb: []
                        }
                    }
                })
            })
        },
        getCashManagements: async function () {
            let queryCashManagement = GET_CASHMANAGEMENT_AACPVI;
            if (gqlmap == 'aafliii') {
                queryCashManagement = GET_CASHMANAGEMENT_AAFLIII;
            } else if (gqlmap == 'ivoryIv') {
                queryCashManagement = GET_CASHMANAGEMENT_IVORYIV;
            } else if (gqlmap == 'MDIv') {
                queryCashManagement = GET_CASHMANAGEMENT_MDIV;
            }
            this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                let data = await this.$apollo.query({
                    query: queryCashManagement,
                    fetchPolicy: 'network-only'
                })
                return (data ? data : {
                    data: {
                        data: {
                            cashManagement: []
                        }
                    }
                })
            })
        },
        getExcavations: async function () {
            this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                let data = await this.$apollo.query({
                    query: GET_EXCAVATIONS,
                    fetchPolicy: 'network-only'
                })
                return (data ? data : {
                    data: {
                        data: {
                            excavation: []
                        }
                    }
                })
            })
        },
        deleteSQLData(data) {
            let w = this;
            w.spinner = true
            try {
                let obj = {}
                data = JSON.parse(JSON.stringify(data))
                let results = [...data.map(x => x.DealID)]
                let json = JSON.stringify(data);
                let query = this.mutations[`DELETE_${this.gqlmap.toUpperCase()}S`]
                let variableData = {};
                if(this.gqlmap == "entitydbCd"){
                    variableData = {
                        CompanyName: data[0].CompanyName
                    }
                } else if(this.gqlmap == "entitydbLa"){
                    variableData = { 
                        CompanyName: data[0].CompanyName
                    }
                } else if(this.gqlmap == "entitydbRt"){
                    variableData = {
                        CompanyName: data[0].CompanyName
                    }
                }
                this.$apollo.mutate({
                    mutation: query,
                    variables: variableData
                })
                    .then(res => {
                        w.spinner = false;
                        if (res) {
                            if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                this.sheetChanges = [];
                                this.gridApi.flashCells({
                                    rowNodes: []
                                })
                                this.gridApi.deselectAll();
                                this.runQuery(true);
                                this.$modal.show('dialog', {
                                    title: 'Success!',
                                    text: 'Deletes sucessfully applied',
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Error!',
                                    text: 'Deletes not applied',
                                    class: 'failure'
                                })
                            }
                        }
                    })
                    .catch(err => {
                        w.spinner = false;
                        this.$modal.show('dialog', {
                            title: 'Error!',
                            text: err,
                            class: 'failure'
                        })
                    })
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        upsertSQLData(data) {
            let w = this;
            w.spinner = true
            try {
                let obj = {}
                if (this.auditLog && this.auditLog.length > 0) {
                    this.auditLog.map(x => {
                        obj[x.key] = x
                    })
                }
                data = JSON.parse(JSON.stringify(data));
                delete data[0].__typename;
                delete data[0].system_modified;
                delete data[0].system_inserted;
                // data.map(x => {
                //     if (x[this.keyfield] && obj[x[this.keyfield]]) x.audit = obj[x[this.keyfield]]
                // })
                let json = JSON.stringify(data);
                let query = this.mutations[`UPSERT_${this.gqlmap.toUpperCase()}S`]
                let variableData = {};
                if(this.gqlmap == "entitydbCd"){
                    variableData = {
                        CompanyName: data[0].CompanyName,
                        EntityDB_CompanyDetails_set_input: data[0]
                    }
                } else if(this.gqlmap == "entitydbLa"){
                    variableData = {
                        CompanyName: data[0].CompanyName,
                        EntityDB_LPAAmendments_set_input: data[0]
                    }
                } else if(this.gqlmap == "entitydbRt"){
                    variableData = {
                        CompanyName: data[0].CompanyName,
                        EntityDB_RegulatoryTax_set_input: data[0]
                    }
                } else if(this.gqlmap == "excavation"){
                variableData = { data: json }
                }
                this.$apollo.mutate({
                    mutation: query,
                    variables: variableData
                })
                    .then(res => {
                        w.spinner = false;
                        if (res) {
                            if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                this.dataChanges = [];
                                this.rowsupdated = [];
                                this.sheetChanges = [];
                                this.gridApi.flashCells({
                                    rowNodes: []
                                })
                                this.gridApi.deselectAll();
                                this.auditLog = [];
                                this.sheetChanged = false;
                                this.runQuery(true);
                                this.$modal.show('dialog', {
                                    title: 'Success!',
                                    text: 'Updates sucessfully applied',
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Error!',
                                    text: 'Updates not applied<br/>',
                                    class: 'failure'
                                })
                            }
                        }
                    })
                    .catch(err => {
                        w.spinner = false;
                        this.$modal.show('dialog', {
                            title: 'Error!',
                            text: err,
                            class: 'failure'
                        })
                    })
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        insertSQLData(data) {
            let w = this;
            w.spinner = true
            try {
                let obj = {}
                if (this.auditLog && this.auditLog.length > 0) {
                    this.auditLog.map(x => {
                        obj[x.key] = x
                    })
                }
                data = JSON.parse(JSON.stringify(data));
                delete data[0].__typename;
                delete data[0].system_modified;
                delete data[0].system_inserted;
                // data.map(x => {
                //     if (x[this.keyfield] && obj[x[this.keyfield]]) x.audit = obj[x[this.keyfield]]
                // })
                let json = JSON.stringify(data);
                let query = this.mutations[`INSERT_${this.gqlmap.toUpperCase()}S`]
                let variableData = {};
                if(this.gqlmap == "entitydbCd"){
                    variableData = {
                        EntityDB_CompanyDetails_insert_input: data[0]
                    }
                } else if(this.gqlmap == "entitydbLa"){
                    variableData = {
                        EntityDB_LPAAmendments_insert_input: data[0]
                    }
                } else if(this.gqlmap == "entitydbRt"){
                    variableData = {
                        EntityDB_RegulatoryTax_insert_input: data[0]
                    }
                }
                this.$apollo.mutate({
                    mutation: query,
                    variables: variableData
                })
                    .then(res => {
                        w.spinner = false;
                        if (res) {
                            if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                this.dataChanges = [];
                                this.rowsupdated = [];
                                this.sheetChanges = [];
                                this.gridApi.flashCells({
                                    rowNodes: []
                                })
                                this.gridApi.deselectAll();
                                this.auditLog = [];
                                this.sheetChanged = false;
                                this.runQuery(true);
                                this.$modal.show('dialog', {
                                    title: 'Success!',
                                    text: 'Updates sucessfully applied',
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Error!',
                                    text: 'Updates not applied<br/>',
                                    class: 'failure'
                                })
                            }
                        }
                    })
                    .catch(err => {
                        w.spinner = false;
                        this.$modal.show('dialog', {
                            title: 'Error!',
                            text: err,
                            class: 'failure'
                        })
                    })
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        addFund() {
            let mapping = sqlTables && sqlTables[this.gqlmap] && sqlTables[this.gqlmap].mapping ? sqlTables[this.gqlmap].mapping : {}
            mapping = JSON.parse(JSON.stringify(mapping))
            let w = this;
            let defaultName = ''
            let buttons = [{
                title: 'OK',
                handler: () => {
                    let input = document.getElementById('nameDialog')
                    defaultName = input.value
                    let column = input.value.replace(/ /g, '_')
                    this.mapping[column] = {
                        column: column,
                        dataType: 'currency',
                        header: defaultName,
                        sum: true,
                        type: 'commitment',
                        inserted: true
                    }
                    let series = JSON.parse(JSON.stringify(this.series))
                    series = series.map(x => {
                        x[column] = 0;
                        return x
                    })
                    this.series = series;
                    w.$modal.hide('customDialog');
                    setTimeout(() => {
                        let index = this.columnDefs.findIndex(x => x.field == column)
                        if (index >= 0) {
                            let allColumns = this.gridOptions.columnApi.getAllColumns();
                            let column = allColumns[index];
                            if (column) {
                                this.gridOptions.api.ensureColumnVisible(column);
                            }
                        }
                    }, 0)

                }
            },
            {
                title: 'Cancel',
                default: true,
                handler: () => {
                    w.closable = false;
                    w.$modal.hide('customDialog');
                }
            }
            ]
            w.$modal.show('customDialog', {
                title: 'Fund Name',
                text: `<input id="nameDialog" autofocus autocomplete="off" spellcheck="false" value=${'"' + defaultName + '"'}>`,
                class: undefined,
                buttons: buttons
            })
        },
        dateFormat(value) {
            return (new Date(value)).toLocaleDateString()
        },
        loadSheet: async function (evt) {
            try {
                let w = this;
                let rows = []
                let data = new Uint8Array(evt);
                if (data && data.length) {
                    let workbook = await XLSX.read(data, {
                        type: 'array'
                    });
                    let json = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
                    if (json && json[0].Term) {
                        let map = {}
                        let reversemap = {}
                        let fields = Object.keys(this.mapping)
                        let columns = fields.map(x => this.mapping[x].header)
                        columns.map((x, i) => {
                            map[x] = fields[i]
                            reversemap[fields[i]] = x;
                        })
                        let value = {}
                        json.map(x => {
                            value[x.Term.replace(/\n/g, '').replace(/\r/g, '')] = x.Value
                        })
                        let sources = {}
                        let citation = {}
                        if (this.gqlmap === 'excavation') {
                            json.map(x => {
                                if (x.Citation) {
                                    citation[x.Term] = x.Citation
                                } else {
                                    citation[x.Term] = '-'
                                }
                            })
                        }
                        let row = {}
                        Object.keys(value).map((y, n) => {
                            y = y.replace(/\n/g, '').replace(/\r/g, '')
                            let key = map[y] ? map[y] : y.replace(/ /g, '_').replace(/-/g, '_').replace(/\#/g, '').replace(/\,/g, '').replace(/^20/, 'Y20').replace(/\(/g, '').replace(/\)/g, '').replace(/Fund_Name/, 'FundName')
                            key = key == 'Deal_ID' ? 'DealID' : key;
                            if (key === w.keyfield) sources[key] = w.mapping[key] && (w.mapping[key].dataType === 'number') ? parseInt(value[y]) : value[y]
                            if (w.series[0] && fields.findIndex(z => z == key) < 0) {
                                console.log(key + ' is missing')
                            } else {
                                //console.log(key, value[y]);
                            }
                            if (!isNaN(value[y]) && w.mapping[key] && w.mapping[key].dataType === 'number') {
                                value[y] = parseInt(value[y])
                            }
                            if (!isNaN(value[y]) && !isNaN(parseInt(value[y])) && w.mapping[key] && (w.mapping[key].dataType === 'date' || key.indexOf('Date') >= 0)) {
                                let dateval = Math.round((value[y] - 25568) * 86400 * 1000)
                                let date = new Date(Date.UTC(0, 0, parseInt(value[y]), -17));
                                let formattedDate = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear()
                                if (date.getFullYear() == '1969') {
                                    value[y] = null
                                } else {
                                    value[y] = date.toISOString()
                                }
                            }
                            row[key] = value[y]
                            if (this.gqlmap === 'excavation') {
                                if (citation[y]) {
                                    let source = citation[y]
                                    sources[key] = source
                                }
                            }
                        })
                        row.system_modified = true;
                        row.system_inserted = true;
                        rows.push(row)
                        data = row
                        let index = w.series.findIndex(y => y[w.keyfield] == data[w.keyfield])
                        if (index >= 0 || !data[w.keyfield]) {
                            if (index >= 0) {
                                this.$modal.show('dialog', {
                                    title: 'Duplicate detected',
                                    text: `This ${reversemap[w.keyfield]} appears to already exist<br>Please verify and retry`,
                                    class: 'failure'
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Deal ID required',
                                    text: `This ${reversemap[w.keyfield]} appears to be missing, please enter a Deal ID and retry`,
                                    class: 'failure'
                                })
                            }
                            this.filereader = Date.now()
                        } else {
                            let user = this.$store.getters.get('user')
                            user = user && user.username ? user.username : 'unknown'
                            let name = data[w.keyfield]
                            Object.keys(data).map((x, i) => {
                                if (x != w.keyfield) {
                                    let index = fields.findIndex(y => y == x)
                                    let event = {
                                        oldValue: '',
                                        newValue: data[x],
                                        colDef: {
                                            headerName: columns[index]
                                        }
                                    }
                                    let change = `<p class='dialog-text'>${name} > ${event.colDef.headerName}<br/><i style='color:brown'>${event.oldValue ? event.oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${event.newValue}</i></p>`
                                    let audit = {
                                        user: user,
                                        key: data[w.keyfield],
                                        old: event.oldValue ? event.oldValue : 'Empty',
                                        new: event.newValue,
                                        timestamp: Date.now()
                                    }
                                    if (w.sheetChanges.findIndex(x => x === change) < 0) {
                                        w.sheetChanges.push(change)
                                        w.auditLog.push(audit)
                                        w.sheetChanged = true;
                                    }
                                }
                            })
                            if (w.dataChanges.findIndex(x => x[w.keyfield] == data[w.keyfield]) >= 0) {
                                w.dataChanges.splice(w.dataChanges.findIndex(x => x[w.keyfield] == data[w.keyfield]), 1)
                            }
                            if (Object.keys(sources).length > 1) {
                                sources.dataType = 'citation'
                                w.dataChanges.push(sources)
                            }
                            w.dataChanges.push(data)
                            this.spinner2 = false;
                            if (rows.length > 0) {
                                if (Object.keys(sources).length > 0) w.citations[row.DealID] = sources
                                w.series = rows.concat(w.series)
                            }
                            this.filereader = Date.now()
                        }
                    }
                }
            } catch (err) {
                this.filereader = Date.now()
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
                this.spinner2 = false;
            }
        },
        renderPercent: function (value) {
            value.value = parseFloat(value.value) < 0 ? 0 : parseFloat(value.value) > 100 ? 100 : value.value
            return value.value ? 100 * parseFloat(value.value) + '%' : null
        },
        onFilterChanged(ev) {
            let w = this;
            this.drawersorted = Date.now()
            if (ev && ev.api && ev.api.rowModel && ev.api.rowModel.rowsToDisplay) {
                w.setFilter = {
                    selectedRows: ev.api.rowModel.rowsToDisplay
                };
            }
        },
        saveChanges() {
            let ok = [{
                title: 'OK',
                default: true,
                handler: () => {
                    this.$modal.hide('dialog');
                }
            }]
            let buttons = [{
                title: 'Update',
                handler: () => {
                    let data = JSON.parse(JSON.stringify(this.dataChanges))
                    data.map(x => {
                        delete x.rowIndex
                    })
                    if(data[0].system_inserted){
                        this.insertSQLData(data)
                    } else {
                        this.upsertSQLData(data)
                    }
                    this.$modal.hide('dialog');
                }
            },
            {
                title: 'Cancel',
                default: true,
                handler: () => {
                    this.$modal.hide('dialog');
                }
            }
            ]
            this.$modal.show('dialog', {
                title: 'Apply Changes?',
                width: '600px',
                maxHeight: '600px',
                text: this.sheetChanges.join('<br/>'),
                class: 'sheet-changes',
                buttons: buttons
            })
        },
        getDatePickerUI() {
            function Datepicker() { }
            Datepicker.prototype.init = function (params) {
                this.eInput = document.createElement("input");
                this.eInput.value = params.value;
                $(this.eInput).datepicker({
                    dateFormat: "dd/mm/yy",
                    onSelect: function (dateText, inst) {
                        params.stopEditing();
                    }
                });
            };
            Datepicker.prototype.getGui = function () {
                return this.eInput;
            };
            Datepicker.prototype.afterGuiAttached = function () {
                this.eInput.focus();
                this.eInput.select();
            };
            Datepicker.prototype.getValue = function () {
                return this.eInput.value;
            };
            Datepicker.prototype.destroy = function () { };
            Datepicker.prototype.isPopup = function () {
                return true;
            };
            return Datepicker;
        },
        loadTextFromFile(ev) {
            const file = ev.target.files[0];
            const reader = new FileReader();

            reader.onload = e => this.$emit("load", e.target.result);
            reader.readAsText(file);
        },
        exportData: function (event) {
            this.writeSheet()
        },
        onSortChangedEvent(event) {
            this.drawersorted = Date.now()
        },
        writeSheet() {
            this.spinner2 = true;
            if (this.rowData) {

                let name = `${this.$route.name}.export.${this.customDateFormat}.xlsx`
                var data = this.setFilter && this.setFilter.selectedRows && this.setFilter.selectedRows.length > 0 ? this.setFilter.selectedRows : this.rowData;
                data = data.map(x => x.data ? x.data : x)
                var rows = [];
                var columns = this.columnDefs.map(x => x.headerName)
                var fields = this.columnDefs.map(x => x.field)
                rows.push(columns);
                data.forEach(function (p) {
                    var result = []
                    fields.map(x => result.push(p[x]))
                    rows.push(result)
                })
                var headers = {}
                this.columnDefs.map(x => {
                    headers[x.field] = x.headerName
                })
                var sheethtml = new Table({
                    'class': 'tableHTML'
                }).setHeaders(headers).setData(data).render()
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(rows);
                XLSX.utils.book_append_sheet(wb, ws, "table");
                XLSX.writeFile(wb, name, {
                    compression: true
                });
            } else {
                console.log('Nothing to export..')
            }
            this.spinner2 = false;
        },
        onDragStopped() {
            var headers = [];
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            columns.forEach((col, i) => {
                if (col.colDef.field !== 'sample' && col.colDef.field !== 'distance') {
                    headers.push(col.colDef.field)
                }
            })
            this.$store.commit('change', {
                g25chartComponents: headers
            })
            this.components = headers;
            var series = this.series;
            var result = []
            headers.forEach(component => {
                result.push(series.find(item => item.name === component))
            })
            this.$store.commit('change', {
                g25chartSeries: result
            })
        },
        paginationChanged: function (event) {
            this.gridApi = this.gridOptions.api;
            this.gridApi.flashCells({
                rowNodes: this.rowsupdated
            })
        },
        onCellEditingStopped: function (event) { },
        onRowEditingStopped: function (event) { console.log("on row editing stopped"); },
        onCellEditingStarted: function (event) {
            let w = this;
            const savedState = w.gridOptions.columnApi.getColumnState();
            const filterState = w.gridOptions.api.getFilterModel();
            w.savedState = savedState;
            w.filterState = filterState;
        },
        isLetter(str) {
            var regexp = /[A-Za-z_/-]/i;
            return regexp.exec(str);
        },
        onCellValueChanged: function (event) {
            let w = this;
            event.newValue = (typeof event.newValue === 'object') ? event.newValue.label : event.newValue; 
            if (event.oldValue !== event.newValue) {
                let data = event.data
                data.rowIndex = event.rowIndex
                let rowNode = event.node
                let column = event.column.colId;
                data[column] = (((this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv' ) && this.isLetter(event.newValue) === null) && event.newValue.toString() != "") ? w.handleNegetiveValue(event.newValue) : event.newValue;

                if(column == "BalancedCKG"){
                    var balanceCKG = w.getCellFormattedValue(event.newValue);
                    var fRBBalance = w.getCellFormattedValue(data["FRBBalancedCKG"]);
                    data["CoInvestCKG"] = w.handleNegetiveValue(parseFloat(fRBBalance - balanceCKG).toFixed(2));
                }
                if(column == "CoInvestCKG"){
                    var coInvestCKG = w.getCellFormattedValue(event.newValue);
                    var fRBBalance = w.getCellFormattedValue(data["FRBBalancedCKG"]);
                    data["BalancedCKG"] = w.handleNegetiveValue(parseFloat(fRBBalance - coInvestCKG).toFixed(2));
                }

                if(column == "FRBBalancedCKG"){
                    var itemdata = w.splitdata.filter( function(item){ return item["iLevel Deal Name"] == data["Deal"]});
                    var total = itemdata.map(item => item["Deal Commitment"]).reduce((a,c) => {return a+c });

                    itemdata.forEach(element => {
                        if(element["Co-Investment Deal"]){
                            var p1 = ((element["Deal Commitment"]/total)*100).toFixed(2);
                            data["CoInvestCKG"] = w.handleNegetiveValue(parseFloat(event.newValue * p1 / 100).toFixed(2));
                        } else {
                            var p2 = ((element["Deal Commitment"]/total)*100).toFixed(2);
                            data["BalancedCKG"] = w.handleNegetiveValue(parseFloat(event.newValue * p2 / 100).toFixed(2));
                        }
                    });
                }

                w.gridApi.redrawRows(event);
                if (w.rowsupdated.findIndex(x => x.rowIndex == rowNode.rowIndex) < 0) {
                    w.rowsupdated.push(rowNode);
                }
                event.api.flashCells({
                    rowNodes: w.rowsupdated
                })
                let user = this.$store.getters.get('user')
                user = user && user.username ? user.username : 'unknown'
                let name = event.data.CommonName ? event.data.CommonName + ':' : ''
                let change = `<p class='dialog-text'>${name} > ${event.colDef.headerName}<br/><i style='color:brown'>${event.oldValue ? event.oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${event.newValue}</i></p>`
                let audit = {
                    user: user,
                    key: data[this.keyfield],
                    old: event.oldValue ? event.oldValue : 'Empty',
                    new: event.newValue,
                    timestamp: Date.now()
                }
                if (this.sheetChanges.findIndex(x => x === change) < 0) {
                    if (this.dataChanges.findIndex(x => x.rowIndex == data.rowIndex) >= 0) this.dataChanges.splice(this.dataChanges.findIndex(x => x.rowIndex == data.rowIndex), 1)
                    this.dataChanges.push(data)
                    this.sheetChanges.push(change)
                    this.auditLog.push(audit)
                    this.sheetChanged = true;
                } 
            }
            if (!w.drawer) {
                setTimeout(() => {
                    if (w.filterState) {
                        w.gridOptions.api.setFilterModel(w.filterState);
                    }
                }, 0)
            }
            
        },
        onCellDblClicked(evt) {
            let w = this;
            if (evt.colDef && !evt.colDef.editable) {
                const savedState = w.gridOptions.columnApi.getColumnState();
                const filterState = w.gridOptions.api.getFilterModel();
                w.savedState = savedState;
                w.filterState = filterState;
                this.currentRow = evt.rowIndex;
                this.gridOptions.api.doLayout();
                this.filteredData = this.setFilter && this.setFilter.selectedRows && this.setFilter.selectedRows.length > 0 ? this.setFilter.selectedRows.map(x => x.data) : this.rowData ? this.rowData : []
                let model = w.gridOptions.api.getModel()
                let sort = []
                let sortmodel = w.gridOptions.api.getSortModel()[0]
                if (sortmodel != w.sortmodel) {
                    if (model && model.rowsToDisplay && model.rowsToDisplay[0] && model.rowsToDisplay[0].data && model.rowsToDisplay[0].data[w.keyfield]) {
                        model.rowsToDisplay.map(x => {
                            sort.push(x.data[w.keyfield])
                        })
                        const sorter = function (a, b) {
                            return sort.indexOf(a[w.keyfield]) - sort.indexOf(b[w.keyfield])
                        }
                        if (sort.length > 0) {
                            w.filteredData.sort(sorter);
                        }
                        this.drawersorted = Date.now();
                        w.sortmodel = sortmodel
                    }
                }
                setTimeout(() => {
                    this.drawer = true;
                    setTimeout(() => {
                        if (this.$refs.carousel && this.$refs.carousel.swiper) this.$refs.carousel.swiper.slideTo(evt.rowIndex, 0)
                    }, 0)
                }, 10)
            }
        },
        onRowDblClicked(evt) { },
        onSelectionChanged() {
            this.gridApi = this.gridOptions.api;
            var selectedRows = this.gridApi.getSelectedRows();
            if (selectedRows.length > 0) {
                this.rowsSelected = true;
                if (this.gqlmap === 'excavation' || this.gqlmap === 'entitydb' || this.gqlmap === 'entitydbCd' || this.gqlmap === 'entitydbLa' || this.gqlmap === 'entitydbRt' || this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv') this.deleteRows = true;
            } else {
                this.rowsSelected = false;
                this.deleteRows = false;
            }
        },
        addEntity: function (event) {
            //let entity = this.gqlmap && this.modals.indexOf(this.gqlmap) >= 0 ? `add${this.gqlmap}` : 'addentity'
            //this.$modal.show(entity, {
            //    action: 'add',
            //    index: {
            //        module: this.module
            //    }
            //});

            // TODO: empty data collection need to prepare
            let w = this;
            let rowindex = w.rowData.length
            //let rowNode = w.gridApi.getRowNode(rowindex-1)
            const data = w.rowData;
            const newRow = data[0];
            let newData = {};
            Object.keys(newRow).forEach(key => {
                if (key == "Deal"){
                    newData[key] = null;
                } else {
                    newData[key]= null;
                }
            })
            w.rowData.push(newData);
            
            this.gridApi = this.gridOptions.api;
            if (this.gqlmap === 'excavation' || this.gqlmap === 'entitydb' || this.gqlmap === 'entitydbCd' || this.gqlmap === 'entitydbLa' || this.gqlmap === 'entitydbRt') {
                this.gridApi.applyTransaction({add: [{}], addIndex: 0});
            } else if(this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv') {
                this.gridApi.applyTransaction({add: [newData]});
            }
            //this.gridApi.updateRow({add: {}, addIndex: 0})
        },
        setModule: function () {
            let module = (this.$store.getters.get('module'))
            this.module = module;
            let subModule = (this.$store.getters.get('submodule'))
            this.subModule = subModule;
        },
        modelUpdated: function () { },
        gridReady: function () {
            this.gridApi = this.gridOptions.api;
        },
        runQuery: async function (refresh) {
            this.drawersorted = Date.now();
            this.series = []
            this.spinner = true;
            let w = this;
            refresh = refresh ? true : false;
            this.rowsupdated = []
            try {
                w.citations = {}
                this.$store.commit('change', {
                    slideWrapper: 'hidden'
                })
                let gqlmap = (this.$store.getters.get('gqlmap'));
                if (gqlmap) {
                    //var query = asiaAltQueries[gqlmap].list
                    let gqldata;
                    if (gqlmap == 'excavation') {
                        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                            let data = await this.$apollo.query({
                                query: GET_EXCAVATIONS,
                                fetchPolicy: 'network-only'
                            })
                            setTimeout(() => {
                                if (data.data) {
                                    if (Object.keys(data.data).length > 0) {
                                        let q = Object.keys(data.data)[0]
                                        this.series = JSON.parse(JSON.stringify(data.data[q]));
                                        this.$store.commit('change', {
                                            slideWrapper: 'visible'
                                        })
                                    }
                                }
                                this.spinner = false;
                                if (w.gridApi) {
                                    w.gridApi.flashCells({
                                        rowNodes: w.rowsupdated
                                    })
                                }
                            }, 301)

                            if (data.data) {
                                let citations = await this.$apollo.query({
                                    query: GET_EXCAVATIONS_CITATIONS,
                                    id: refresh ? 'citations:' + Date.now() : 'citations:0',
                                    fetchPolicy: refresh ? 'no-cache' : 'network-only'
                                })
                                if (citations && citations.data && Object.keys(citations.data).length > 0) {
                                    let table = Object.keys(citations.data)[0]
                                    let obj = {}
                                    citations.data[table].map(x => {
                                        obj[x.DealID] = x
                                    })
                                    w.citations = {
                                        ...obj
                                    };
                                }
                                this.spinner = false;
                            }
                        })
                    } else if (gqlmap == 'entitydb' || gqlmap == 'entitydbCd' || gqlmap == 'entitydbLa' || this.gqlmap === 'entitydbRt') {
                        let queryEntity = GET_ENTITYDBS;
                        if (gqlmap == 'entitydbCd') {
                            queryEntity = GET_ENTITYDBS_CD;
                        } else if (gqlmap == 'entitydbLa') {
                            queryEntity = GET_ENTITYDBS_LA;
                        } else if (this.gqlmap === 'entitydbRt') {
                            queryEntity = GET_ENTITYDBS_RT;
                        }
                        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                            let data = await this.$apollo.query({
                                query: queryEntity,
                                fetchPolicy: refresh ? 'network-only' : undefined
                            })
                            setTimeout(() => {
                                if (data.data) {
                                    if (Object.keys(data.data).length > 0) {
                                        let q = Object.keys(data.data)[0]
                                        this.series = JSON.parse(JSON.stringify(data.data[q]));
                                        this.$store.commit('change', {
                                            slideWrapper: 'visible'
                                        })
                                    }
                                }
                                this.spinner = false;
                                if (w.gridApi) {
                                    w.gridApi.flashCells({
                                        rowNodes: w.rowsupdated
                                    })
                                }
                            }, 301)
                        })
                    } else if (gqlmap == 'aacpVi' || gqlmap == 'aafliii' || gqlmap == 'ivoryIv' || gqlmap == 'MDIv') {
                        let queryCashManagement = GET_CASHMANAGEMENT_AACPVI;
                        if (gqlmap == 'aafliii') {
                            queryCashManagement = GET_CASHMANAGEMENT_AAFLIII;
                        } else if (gqlmap == 'ivoryIv') {
                            queryCashManagement = GET_CASHMANAGEMENT_IVORYIV;
                        } else if (gqlmap == 'MDIv') {
                            queryCashManagement = GET_CASHMANAGEMENT_MDIV;
                        }
                        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                            let data = await this.$apollo.query({
                                query: queryCashManagement,
                                fetchPolicy: refresh ? 'network-only' : undefined
                            })
                            setTimeout(() => {
                                // if (data.data) {
                                //     if (Object.keys(data.data).length > 0) {
                                //         let q = Object.keys(data.data)[0]
                                //         this.series = JSON.parse(JSON.stringify(data.data[q]));
                                //         this.$store.commit('change', {
                                //             slideWrapper: 'visible'
                                //         })
                                //     }
                                // }
                                let aacpdata = mockdata;
                                if (gqlmap == 'aafliii') {
                                    aacpdata = mockdataaafliii;
                                } else if (gqlmap == 'ivoryIv') {
                                    aacpdata = mockdataivoryiv;
                                } else if (gqlmap == 'MDIv') {
                                    aacpdata = mockdatamdiv;
                                }
                                if (aacpdata) {
                                    if (Object.keys(aacpdata.data).length > 0) {
                                        let q = Object.keys(aacpdata.data)[0]
                                        this.series = JSON.parse(JSON.stringify(aacpdata.data[q]));
                                        this.$store.commit('change', {
                                            slideWrapper: 'visible'
                                        })
                                    }
                                }
                                this.spinner = false;
                                if (w.gridApi) {
                                    w.gridApi.flashCells({
                                        rowNodes: w.rowsupdated
                                    })
                                }
                            }, 301)
                        })
                    } else {
                        let data = sqlTables[gqlmap].data
                        setTimeout(() => {
                            if (data.data) {
                                if (Object.keys(data.data).length > 0) {
                                    let q = Object.keys(data.data)[0]
                                    this.series = data.data[q].items;
                                    this.$store.commit('change', {
                                        slideWrapper: 'visible'
                                    })
                                }
                            }
                        }, 301)
                        this.spinner = false;
                    }
                    /*
                this.$apollo.query({
                    query: query,
                    fetchPolicy: 'network-only'
                }).then(data => {
            }).
            catch(err => {
                this.series = []
          this.$store.commit('change', { slideWrapper: 'visible' })
            })
            */
                } else {
                    setTimeout(() => {
                        this.series = []
                        this.$store.commit('change', {
                            slideWrapper: 'visible'
                        })
                    }, 200)
                    this.spinner = false;
                }
            } catch (err) {
                this.spinner = false;
            }
        }
    }
}
